module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/rss-65d61741f40e5bcb660b79c227acfbe1.svg";